/** PB-Filter für `portal_akten` — keine PB-URL/Token-Abhängigkeit (Unit-Tests). */

export function escapePortalAktenPbFilterString(value: string): string {
  return value.replace(/\\/g, '\\\\').replace(/'/g, "\\'");
}

/** PB `portal_akten`: Org (kanzlei_id) oder Legacy-Owner (customer_id) — analog Docs. */
export function buildPortalAktenPbFilter(customerId: string, kanzleiId?: string): string {
  const cid = escapePortalAktenPbFilterString(customerId);
  const kid = escapePortalAktenPbFilterString((kanzleiId || '').trim());
  if (kid) {
    return `(kanzlei_id='${kid}' || customer_id='${cid}')`;
  }
  return `(customer_id='${cid}')`;
}
